import { resultInputDetails } from './resultInputFields.js';
/** Frozen publication facts take precedence over a Domain's current input labels. */
export function getResultMarkSheetSelection(event) {
  if (!event?.resultPublicationId || !event?.markSheetId) return null;
  const selection = {
    domainId: event.domainId, classId: event.classId, programmeId: event.programmeId,
    courseId: event.courseOfferingId, assessmentId: event.assessmentId,
  };
  return Object.values(selection).every(value => typeof value === 'string' && value)
    ? selection : null;
}

export function getPublishedResultPresentation(event) {
  if (!event?.resultPublicationId || !event?.markSheetId || !event?.resultEntry) return null;
  const entry = event.resultEntry;
  let label;
  if (entry.kind === 'points') label = `${entry.value} / ${event.maxScore}`;
  else if (entry.kind === 'level') label = event.resultScale?.options?.find(option => option.id === entry.value)?.label || 'Unavailable Level';
  else if (entry.kind === 'status') label = event.resultStatusLabel || entry.statusId;
  else label = 'Unavailable Result';
  return {
    label,
    details: [
      ...resultInputDetails(event.inputSchema, event.fieldValues),
      { id: 'subject', label: 'Subject', value: event.subject },
      { id: 'assessmentName', label: 'Assessment', value: event.assessmentName },
      { id: 'resultRevision', label: 'Revision', value: event.resultRevision == null ? null : String(event.resultRevision) },
    ].filter(item => item.value != null && item.value !== ''),
  };
}
